import { axiosPrivate } from "../axios";
import useRefreshToken from "./useRefreshToken";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { clearAuthData } from "../store/authSlice";
import { clearAllUserData } from "../store/userSlice";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const dispatch = useDispatch();

  // Получаем токен из Redux для отслеживания изменений
  const { auth_token } = useSelector((state) => state.auth);

  // Получаем токен из localStorage напрямую, а не из Redux
  const getAuthToken = () => {
    // Сначала проверяем прямое сохранение токена (новая логика)
    const directToken = localStorage.getItem("auth_token");
    if (directToken) {
      return directToken;
    }

    // Фоллбэк на старую структуру authState (для совместимости)
    const authState = localStorage.getItem("authState");
    if (authState) {
      const parsed = JSON.parse(authState);
      return parsed.auth_token;
    }
    return null;
  };

  useEffect(() => {
    console.log(
      "🔄 [useAxiosPrivate] Переинициализация interceptor, токен:",
      auth_token?.substring(0, 30) + "..."
    );

    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        const token = getAuthToken();
        if (!config.headers["Authorization"]) {
          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
            console.log(
              `🔐 [useAxiosPrivate] Токен подставлен в ${config.method?.toUpperCase()} ${
                config.url
              }:`,
              token?.substring(0, 30) + "..."
            );
          } else {
            console.warn(
              `⚠️ [useAxiosPrivate] НЕТ ТОКЕНА для ${config.method?.toUpperCase()} ${
                config.url
              }`
            );
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest?._retry) {
          prevRequest._retry = true;
          try {
            console.log("🔄 Попытка обновить токен...");
            const newAccessToken = await refresh();
            prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            return axiosPrivate(prevRequest);
          } catch (refreshError) {
            console.log("❌ Ошибка обновления токена, выходим из аккаунта");
            console.error("Refresh token error:", refreshError);

            return Promise.reject(refreshError);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [refresh, auth_token, dispatch]);

  return axiosPrivate;
};

export default useAxiosPrivate;
